<label class="multi-select-radio radio"
  [ngClass]="{'list-item-img mx-1': option.frmt === INPUT_FILE, 'list-item w-100': option.frmt !== INPUT_FILE}"
  *ngFor="let option of options">
  <input #radio [name]="question.name" [value]="option.code" type="radio"
    [checked]="getSelectedRadioStatus(option.code, prefilled?.length ? prefilled : [])"
    [disabled]="isViewMode" (click)="setRadio(option.code, question.name, (option.frmt === INPUT_FILLED && radio?.checked), option?.pty)" />
  <div class="item-img" [ngClass]="{'img-disabled': isViewMode}" *ngIf="option.frmt === INPUT_FILE">
    <span></span>
    <img [src]="fileSignedUrls && fileSignedUrls[option?.pty?.mdc] ? fileSignedUrls[option?.pty?.mdc] : undefined" alt="option" onerror="this.src='assets/themes/icons/banner-placeholder.svg'">
    <small class="zoom" (click)="$event.preventDefault();$event.stopPropagation();zoomImg(fileSignedUrls && fileSignedUrls[option?.pty?.mdc] ? fileSignedUrls[option?.pty?.mdc] : undefined)">
      <img src="assets/images/zoom.svg" alt="zoom" width="24" height="24">
    </small>
  </div>
  <span>
    <span *ngIf="option.frmt !== INPUT_FILE">
      {{option.ov ? option.ov : defaultTxt}}
    </span>
    <div class="form-input ml-n4 mt-2" *ngIf="option.frmt === INPUT_FILLED && (radio?.checked)">
      <input class="input-field" type="text" [placeholder]="placeholder"
        [disabled]="isViewMode"
        [readonly]="isViewMode"
        [attr.minLength]="question?.pty?.min ? question?.pty?.min : null"
        [attr.maxLength]="question?.pty?.max ? question?.pty?.max : null"
        [value]="getOtherSelectedValue(option.code, question?.value?.length ? question?.value : [])"
        (input)="setRadioOtherOption($event.target.value, option.code, question.name, {pattern: getValidationPattern(option?.pty?.ainpt), minLength: option?.pty?.min, maxLength: option?.pty?.max, name: option?.pty?.ainpt})" />
    </div>
  </span>
</label>
